module.exports = __webpack_public_path__ + "img/flusher_parked.2cd3f43c.svg";